import * as React from 'react';

import classes from './styles.module.scss';

export const PreWrapper: React.FC<React.PropsWithChildren> = ({ children }) => (
  <pre className={classes.preWrapper}>{children}</pre>
);
